import React from "react";
import {Helmet} from 'react-helmet';
import Faqs from "../Page/Faqs";
import Newsletter from "../Page/Newsletter";
import PopularHotels from "../Page/Hotels/Component/PopularHotels";
import PopularFlights from "../Page/PopularFlights";
import FlightsWidgit from "../Page/FlightsWidgit";
import Badge from "../Page/Badge";


function App1() {
  return (
   <>
    <Helmet>     
  <title>Contact Us, Lowest Airfare and offers | cheapflightsprices.com</title>
  <meta name="description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time"/>
  <meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flight booking, cheap flight fares,flight booking offer,Cheap Flights Prices,cheapest ticket booking"/>
<meta property="og:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta property="og:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta property="og:site_name" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta name="Distribution" content="Global" />
<meta name="Robots" content="follow, index, all" />
<meta name="googlebot" content="index, follow" />
<meta http-equiv="Expires" content="never" />
<meta name="document-type" content="public" />
<meta name="revisit-after" content="daily" />
<meta name="country" content="India" />
<meta name="Language" content="English" />
<meta name='rating' content="general" />
<meta name="author" content="cheapflightsprices.com" />
<link rel="canonical" href="https://cheapflightsprices.com/contact-us.html" />
  </Helmet>
   <section id="banner_section" className="innerbannersection">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Contact Us</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
    </div>
  </section>
<Badge/>
 

    <main id="main">
   <section id="contact" className="section-bg">
      <div className="container" data-aos="fade-up">
  <div class="section-header">
    <h2>Contact <strong>Us</strong></h2>
  </div>
  <div class="designcontainer">
    <p>
      At CheapFlightsPrices.com, we are committed to providing you with the best travel search and booking experience. 
      If you have any questions, suggestions, or need assistance with using our platform, we encourage you to reach out to us. 
    </p>

    <p>
      Our team works hard behind the scenes to ensure that you find the most competitive fares and real-time availability for flights and hotels. 
      We are here to help you navigate our platform smoothly and make your travel planning simple and stress-free.
    </p>

    <p>
      Please note that all bookings are completed on our partner websites, and payments, refunds, or cancellations are handled directly by them. 
      CheapFlightsPrices.com acts as a facilitator to guide you in finding the best options efficiently.
    </p>

    <p>
      We value your feedback and strive to continuously improve our services. Your satisfaction and ease of use are our top priorities.
    </p>

  </div>

        <div className="row contact-info">
          <div className="col-md-6">
            <div className="contact-address">
              <i className="bi bi-geo-alt"></i>
              <h3>Address</h3>
              <address>DLF Phase 3 Gurgaon 122002</address>
            </div>
          </div>

        

          <div className="col-md-6">
            <div className="contact-email">
              <i className="bi bi-envelope"></i>
              <h3>Email</h3>
              <p><a href="mailto:cheapflightsprices@gmail.com">cheapflightsprices@gmail.com</a></p>
            </div>
          </div>

        </div>

        <div className="form">
          <form action="https://cheapflightsprices.com/php/contact.php" method="post" role="form" className="php-email-form">
            <div className="row">
              <div className="form-group col-md-6">
                              <input type="text" className="hiddenclasss" name="title" />

                <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" required />
              </div>
              <div className="form-group col-md-6 mt-3 mt-md-0">
                <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required />
              </div>
            </div>
            <div className="form-group mt-3">
              <input type="text" minLength="10" maxLength="13" className="form-control" name="phone" id="phone" placeholder="Phone" required />
            </div>
            <div className="form-group mt-3">
              <textarea className="form-control" name="message" rows="5" placeholder="Message" required ></textarea>
            </div>
      
                              <input type="submit" className="form-control submitbtn" name="submit" placeholder="Submit" value="Send Message" onclick="return SubmitDetails();" />

          </form>
        </div>

      </div>
    </section>
    <PopularFlights/>
        <PopularHotels />
    <Faqs/>
    <Newsletter/>
      </main>
    </>
  );
}
export default App1;



